@if (objectViewData) {
  <div class="object-view-tabbed-sections">
    <mat-tab-group
      mat-align-tabs="center"
      color="accent"
    >
      @for (section of objectViewData.sections; track $index) {
        <mat-tab
          label="{{section.title}}"
          class="object-view-tabbed-sections__tab"
          id="section-{{section.name}}"
        >
          <div class="object-view-tabbed-sections__tab-content">
            <div
              class="object-view-tabbed-sections__fields"
              id="field-{{section.section_fields.length}}"
              [ngClass]="{'center-fields' : section.section_fields.length <= 3}"
            >
              @if (!section.section_fields.length) {
                <div class="object-view-tabbed-sections__no-fields">
                  <span>
                    {{ 'TRANS__OBJECT_VIEW_TABBED_SECTIONS__NO_INFO' | translate }}
                  </span>
                </div>
              }

              @for (sectionField of section.section_fields; track $index) {
                <div
                  class="object-view-tabbed-sections__field-container"
                  [ngClass]="{'object-view__action-buttons': sectionField.action_button,
                              'checklist': section['name'] === 'checklist'}"
                >
                  <div class="object-view-tabbed-sections__field-inner-container">
                    @if (!sectionField.action_button) {
                      <app-display-field-title
                        [titleClass]="'object-view-tabbed-sections'"
                        [field]="sectionField"
                      ></app-display-field-title>
                    }

                    @if (sectionField.items) {
                      <div
                        class="object-view-tabbed-sections__field-content"
                        [ngClass]="{'inline-fields': sectionField['field_type'] === 'inline'}"
                      >
                        @for (item of sectionField.items; track $index) {
                          <div class="object-view-tabbed-sections__field">
                            @if (item.header_values) {
                              <div
                                class="item-header"
                                [ngClass]="{'bold': item.header_values.level === 1}"
                              >
                                <app-object-view-field-values
                                  [fieldValues]="item.header_values"
                                ></app-object-view-field-values>
                              </div>
                            }

                            <app-object-view-field-checkbox
                              [sectionsContainer]="sectionsContainer"
                              [checkboxField]="item.checkbox_field"
                            >
                              @if (item.field_values) {
                                <app-object-view-field-values
                                  [fieldValues]="item.field_values"
                                ></app-object-view-field-values>
                              }
                            </app-object-view-field-checkbox>
                          </div>
                        }
                      </div>
                    }

                    @if (sectionField.action_button) {
                      <ng-container>
                        <app-field-action-button
                          class="section-field__action-button"
                          [sectionsContainer]="sectionsContainer"
                          [fieldTitle]="sectionField.title"
                          [field]="sectionField.action_button"
                        ></app-field-action-button>
                      </ng-container>
                    }
                  </div>
                </div>
              }
            </div>

            @if (objectViewData.object_type !== 'folder') {
              <div class="object-view-tabbed-sections__go-to-button">
                <a
                  mat-stroked-button
                  color="primary"
                  (click)="goToObjectState(this.sectionsContainer.rootObject)"
                  [title]="'TRANS__OBJECT_VIEW_TABBED_SECTIONS__MORE_INFO' | translate"
                >
                  <span>
                    {{ 'TRANS__OBJECT_VIEW_TABBED_SECTIONS__MORE_INFO' | translate }}
                  </span>

                  <mat-icon>
                    chevron_right
                  </mat-icon>
                </a>
              </div>
            }
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
}
